import { createSlice, isPending, isRejected } from "@reduxjs/toolkit";

import { getAuthLogoThunk, getAuthStartPagePictureThunk } from "./thunks";
import { IAuthLogoState } from "./types";

const initialState: IAuthLogoState = {
  authLogo: null,
  startPagePicture: null,
  isLoading: false,
};

export const authLogoSlice = createSlice({
  name: "authLogoSlice",
  initialState,
  reducers: {
    clearStartPagePicture: state => {
      state.startPagePicture = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getAuthLogoThunk.fulfilled, (state, { payload }) => {
      state.authLogo = payload.authLogo;
      state.isLoading = false;
    });
    builder.addCase(
      getAuthStartPagePictureThunk.fulfilled,
      (state, { payload }) => {
        state.startPagePicture = payload.startPagePicture;
        state.isLoading = false;
      }
    );
    builder
      .addMatcher(
        isPending(getAuthStartPagePictureThunk, getAuthLogoThunk),
        state => {
          state.isLoading = true;
        }
      )
      .addMatcher(
        isRejected(getAuthStartPagePictureThunk, getAuthLogoThunk),
        state => {
          state.isLoading = false;
        }
      );
  },
});

export const { clearStartPagePicture } = authLogoSlice.actions;
export default authLogoSlice.reducer;
